import { Languages } from "../../types";
import { createQuotationDictionary } from "./CreateQuotation";
import { QuotationPagesDescriptions } from "./types";

export const getQuotationDescriptions = (systemLang: Languages): QuotationPagesDescriptions => ({
    CREATE: createQuotationDictionary[systemLang],
})